<template>
  <div>
    <BaseTitle :title="$t('content.school_management')" />
    <v-card class="mb-7">
      <div class="pa-5">
        <h3>{{ $t('filter') }}</h3>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              :items="provinces"
              :label="$t('province')"
              :loading="loadingProvinces"
              item-value="provinceId"
              item-text="name"
              clearable
              v-model="form.province"
              @change="getCities"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              :items="cities"
              :label="$t('city')"
              :loading="loadingCities"
              item-value="cityId"
              item-text="name"
              clearable
              v-model="form.city"
              @change="getCity"
            />
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.school_list') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="addSchool">{{ $t('add') }}</v-btn>
            </div>
            <v-dialog v-model="dialogSync" persistent max-width="800">
              <v-card class="pa-5">
                <div class="d-flex justify-center">
                  <svg-icon icon="clock-master" class="succ-featured pa-5" width="300" height="250" />
                </div>
                <v-card-title class="d-flex justify-center">
                  <v-progress-linear indeterminate color="secondary" class="mb-0" />
                </v-card-title>
                <v-card-text class="d-flex justify-center">Downloading....</v-card-text>
              </v-card>
            </v-dialog>
            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in listSchool" :key="item.schoolId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="bank" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.name }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span>
                      {{ $t('table.city') }}:
                      <strong>{{ item.cityName }}</strong>
                      |
                      <span
                        >{{ $t('table.province') }} :
                        <strong>{{ item.provinceName }}</strong>
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="viewItem(item)">{{ $t('view') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="editItem(item)">{{ $t('edit') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item)">{{ $t('table.delete') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listSchool.length" />
        <!-- <v-data-table
          :headers="tableHeader"
          :items="items"
          :loading="table.loading"
          :server-items-length="items.length"
          :options.sync="table.options"
          hide-default-footer
          class="table-custom"
        >
          <template #top>
            <table-header @fetch="getData">
              <template #left>
                <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="addSchool">{{ $t('add') }}</v-btn>
                <v-btn color="primary" outlined class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="dialogImport = true">{{
                  $t('upload')
                }}</v-btn>
                <v-btn color="primary" text class="btn-text-custom mb-2 mb-md-0 mr-md-2" @click="downloadTemplate">{{
                  $t('download_template')
                }}</v-btn>
              </template>
            </table-header>
          </template>
          <template #item.actions="{ item }">
            <v-btn text @click="onDeleteItem(item)" class="mr-1 btn-action-custom"><svg-icon icon="delete" class="red--text"/></v-btn>
            <v-btn text @click="viewItem(item)" class="mr-1 btn-action-custom"><svg-icon icon="view" class="primary--text"/></v-btn>
            <v-btn text @click="editItem(item)" class="btn-action-custom"><svg-icon icon="edit" class="primary--text"/></v-btn>
          </template>
          <template #no-data><NoData /></template>
          <template #loading>
            <img src="@/assets/images/globe.gif" class="pa-4" />
          </template>
        </v-data-table>
        <table-footer @fetch="getData" /> -->
      </div>
    </v-card>

    <!-- Dialog Import -->
    <v-dialog v-model="dialogImport" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('content.import_school') }}</v-card-title>
        <v-card-text>
          <form-group :name="$t('form.file')" :validator="$v.formImport.file" no-gutter>
            <template slot-scope="{ attrs }">
              <v-file-input
                :label="$t('form.file')"
                accept=".jpg,.jpeg,.png,.pdf,.mp4,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp3"
                chips
                show-size
                v-bind="attrs"
                small-chips
                v-model="formImport.file"
                truncate-length="15"
                @input="$v.formImport.file.$touch()"
                @blur="$v.formImport.file.$touch()"
              ></v-file-input>
            </template>
          </form-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="btn-primary-custom" outlined @click="dialogImport = false">{{ $t('close') }}</v-btn>
          <v-btn color="primary btn-primary-custom" @click="importData" :loading="table.loading">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="table.loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';

import { required } from 'vuelidate/lib/validators';
import { fileSize, fileType } from '@/validators';

const extAllowed = ['xls', 'xlsx'];

export default {
  name: 'MasterSchool',
  components: {
    BaseTitle,
    // TableHeader,
    // TableFooter,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'School/items',
      provinces: 'Reference/itemProvinces'
    }),
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities']();
      }
    },
    tableHeader() {
      return [
        { text: this.$t('table.school_name'), value: 'name' },
        { text: this.$t('table.province'), value: 'provinceName' },
        { text: this.$t('table.city'), value: 'cityName' },
        { text: this.$t('table.action'), value: 'actions', sortable: false, width: 200 }
      ];
    }
  },
  validations() {
    return {
      formImport: {
        file: {
          required,
          fileSize: fileSize(500),
          fileType: fileType(extAllowed)
        }
      }
    };
  },
  data: () => ({
    dialogDelete: false,
    currentItem: null,
    loadingCities: false,
    loadingProvinces: false,
    loadingSync: false,
    dialogSync: false,
    dialogImport: false,
    listSchool: [],
    search: '',
    loadingLoad: false,
    form: {
      city: '',
      province: ''
    },
    formImport: {
      file: null
    },
    table: {
      loading: false,
      options: {}
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    getData() {
      if (this.form.city) {
        this.getCity();
      } else {
        this.loadingLoad = true;
        this.$store
          .dispatch('School/fetchList', {
            search: this.search
          })
          .then(data => (this.listSchool = data))
          .finally(() => (this.loadingLoad = false));
      }
    },
    getProvinces() {
      this.loadingProvinces = true;
      this.$store.dispatch('Reference/fetchProvinces').finally(() => (this.loadingProvinces = false));
    },
    getCity() {
      if (this.form.city) {
        this.loadingLoad = true;
        this.$store
          .dispatch('School/getCity', {
            cityId: this.form.city,
            search: this.search
          })
          .then(data => (this.listSchool = data))
          .finally(() => (this.loadingLoad = false));
      } else {
        this.getData();
      }
    },
    getCities() {
      if (!this.form.province) {
        this.$store.commit('Reference/RESET_CITIES');
        this.form.city = null;
        this.getCity();
        return;
      }
      this.loadingCities = true;
      this.$store.dispatch('Reference/fetchCities', this.form.province).finally(() => (this.loadingCities = false));
    },
    addSchool() {
      this.$router.push({ name: 'SchoolCreate' });
    },
    editItem({ schoolId }) {
      this.$router.push({ name: 'SchoolEdit', params: { id: schoolId } });
    },
    viewItem({ schoolId }) {
      this.$router.push({ name: 'SchoolDetail', params: { id: schoolId } });
    },
    onDeleteItem(item) {
      this.dialogDelete = true;
      this.currentItem = item;
    },
    deleteItem() {
      if (!this.currentItem) return false;
      this.table.loading = true;
      this.$store
        .dispatch('School/destroy', this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .finally(() => (this.table.loading = false));
    },
    downloadTemplate() {
      this.table.loading = true;
      this.dialogSync = true;
      this.$store
        .dispatch('School/downloadTemplate')
        .then(response => {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `template_export_school.xlsx`;
          link.click();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.table.loading = false;
          this.dialogSync = false;
        });
    },
    importData() {
      this.$v.formImport.$touch();
      if (this.$v.formImport.$invalid) return false;
      this.table.loading = true;
      this.$store
        .dispatch('School/importData', { ...this.formImport })
        .then(({ data }) => {
          if (data.data.errorImports.length === 0) {
            this.$store.dispatch('general/showSuccessNotification', { message: data.data.message });
          } else {
            var datas = '';
            data.data.errorImports.forEach(element => {
              datas +=
                `
              ` +
                element.message +
                `
              `;
            });
            this.$store.dispatch('general/showErrorNotification', { message: datas });
          }
          this.getData();
          this.formImport.file = null;
          this.dialogImport = false;
          this.$v.$reset();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.table.loading = false));
    }
  },
  created() {
    this.getData();
    this.$store.commit('table/RESET_PAGEABLE');
    this.$store.commit('Reference/RESET_CITIES');
    this.getProvinces();
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
